module.exports = __webpack_public_path__ + "static/media/19ESCAP17.db21dbb6.jpg";